/* eslint-disable jsx-a11y/anchor-is-valid */
import { Alert, Avatar, Button, Divider, Empty, message, Modal } from 'antd';
import CycleModuleRender from './cycleModuleRender';
import styles from 'styles/components/myCyclesDetails.module.scss';
import CycleDeadline from './cycleDeadline';
import { MODULES_ITEMS, REVIEW_VISIBILITY } from 'utils/constants';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  FileTextOutlined,
  InfoCircleOutlined,
  MinusCircleOutlined,
  SendOutlined,
  UserOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { scrollTo } from 'utils/utils';
import { useState } from 'react';
import { releaseReviews } from 'services/api/reviews';

const CycleDetailsReadOnlyRender = ({
  cycle,
  myCycleId,
  reviews,
  user,
  callbackFetch,
}) => {
  const [releaseReviewsLoading, setReleaseReviewsLoading] = useState(false);

  const releaseReviewsFunc = () => {
    setReleaseReviewsLoading(true);
    //revieweeId
    releaseReviews({ revieweeId: user._id, cycleId: myCycleId })
      .then((res) => {
        message.success('Reviews released successfully');
      })
      .catch((err) => {
        console.error('err', err);
        message.error('Failed to release reviews');
      })
      .finally(() => {
        callbackFetch();
        setReleaseReviewsLoading(false);
      });
  };

  return (
    <div className={styles.cycleDetailsReadOnly}>
      {cycle.reviewVisibility === REVIEW_VISIBILITY.IMMEDIATE && (
        <div>
          <Alert
            type="info"
            showIcon={true}
            icon={<InfoCircleOutlined />}
            message={
              'Reviews are visible to employees as soon as they are submitted'
            }
            description={
              <div>
                The employees sees every review as soon as they are submitted.
              </div>
            }
          />
        </div>
      )}
      {cycle.reviewVisibility === REVIEW_VISIBILITY.MANAGER_RELEASE &&
        reviews.some((review) => review.status === 'READY') && (
          <div>
            <Alert
              showIcon={true}
              icon={<WarningOutlined />}
              message={
                'Some reviews are ready but not shared with employee yet'
              }
              description={
                <div>
                  <div>
                    This cycle contains reviews ready that are not yet shared
                    with the employee. <br />
                    You need to manually release them for them to have access to
                    them.
                  </div>
                  <div
                    style={{
                      marginTop: 12,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 12,
                    }}
                  >
                    <Button
                      loading={releaseReviewsLoading}
                      type="primary"
                      icon={<SendOutlined />}
                      onClick={() => {
                        Modal.confirm({
                          title: 'Release reviews to employee',
                          okText: 'Yes, release',
                          okButtonProps: {
                            loading: releaseReviewsLoading,
                            icon: <SendOutlined />,
                          },
                          cancelText: 'No, cancel',
                          content:
                            'Are you sure you want to release the reviews?',
                          onOk: () => {
                            releaseReviewsFunc();
                          },
                        });
                      }}
                    >
                      Release reviews
                    </Button>
                  </div>
                </div>
              }
              type="warning"
            />
          </div>
        )}
      {cycle.reviewVisibility === REVIEW_VISIBILITY.MANAGER_RELEASE &&
        reviews.every((review) => review.status === 'DONE') && (
          <div>
            <Alert
              style={{ border: 'none' }}
              type="success"
              showIcon={true}
              icon={<CheckCircleOutlined />}
              message={'Shared with employee'}
              description={
                'All reviews have been released to the employee. They can now see them.'
              }
            />
          </div>
        )}
      <div className={styles.cycleDetails}>
        <div className={styles.sideWrapper}>
          <h1 style={{ fontSize: 24 }}>{cycle?.name}</h1>
          <CycleDeadline deadline={cycle.deadline} />
          <div className={styles.userInfo}>
            <Avatar
              src={user?.profile?.profilePictureUrl}
              icon={<UserOutlined />}
              size={64}
            />
            <div style={{ fontSize: 16, fontWeight: 'bold' }}>
              {user?.profile?.firstName} {user?.profile?.lastName}
            </div>
            <div style={{ fontSize: 14, color: 'grey' }}>
              {user?.profile?.jobTitle}
            </div>
          </div>
          <div>
            {reviews.length > 0 &&
              reviews.map((review, i) => {
                if (!review || !review.moduleType) {
                  return null;
                }
                return (
                  <div key={review.id} style={{ marginBottom: 12 }}>
                    <a
                      onClick={() => {
                        scrollTo(`#review-${review.id}`);
                      }}
                    >
                      <div style={{ fontWeight: 'bold' }}>
                        <FileTextOutlined />
                        &nbsp;{MODULES_ITEMS[review.moduleType]?.label}
                      </div>
                    </a>
                    {review.from && (
                      <div style={{ color: 'grey' }}>
                        by{' '}
                        <Avatar
                          src={review.from?.profile?.profilePictureUrl}
                          icon={<UserOutlined />}
                          size={20}
                        />{' '}
                        {review.from.profile.firstName}{' '}
                        {review.from.profile.lastName}
                      </div>
                    )}
                    <div className={styles.reviewStatusReadOnly}>
                      {review.status === 'TO_DO' && (
                        <div style={{ color: '#531dab' }}>
                          <ClockCircleOutlined />
                          &nbsp;To do, not yet started
                        </div>
                      )}
                      {review.status === 'IN_PROGRESS' && (
                        <div style={{ color: '#0958d9' }}>
                          <MinusCircleOutlined />
                          &nbsp;In progress, not yet submitted
                        </div>
                      )}
                      {review.status === 'READY' && (
                        <div style={{ color: '#faad14' }}>
                          <WarningOutlined />
                          &nbsp;Ready, not shared with employee yet
                        </div>
                      )}
                      {review.status === 'DONE' && (
                        <div style={{ color: '#39a439' }}>
                          <CheckCircleOutlined />
                          &nbsp;Done, shared with employee
                        </div>
                      )}
                    </div>

                    {i !== reviews.length - 1 && <Divider />}
                  </div>
                );
              })}
          </div>
        </div>
        <div className={styles.contentWrapper}>
          {reviews.length > 0 ? (
            reviews.map((review) => (
              <div key={review.id} id={`review-${review.id}`}>
                <CycleModuleRender
                  cycle={cycle}
                  task={{
                    user: review.from,
                  }}
                  myCycleId={myCycleId}
                  module={cycle?.modules.find(
                    (m) => m.type === review.moduleType
                  )}
                  review={review}
                  hideIfEmpty={true}
                  isReadOnly={true}
                />
                <Divider />
              </div>
            ))
          ) : (
            <Empty
              description="No reviews to display yet"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CycleDetailsReadOnlyRender;
